import { useState, useContext, useEffect } from "react"
import { Dropdown } from "primereact/dropdown"

import { UserContext } from "../../../../context/userContext"
import { useNavigate } from "react-router-dom"
import _ from "lodash"
import { useQuery, gql } from "@apollo/client"

export default function SelectOrganization(props) {
  const [loading, setLoading] = useState(false)
  const userCtx = useContext(UserContext)
  const navigate = useNavigate()
  const [userStatus, setUserStatus] = useState("")

  const sortedOrganizations = _.orderBy(
    props.organizationList,
    ["organization_name"],
    ["asc"]
  )

  const SESSION_DATA_QUERY = gql`
    query SessionData($staff_id: ID!, $organization_id: ID) {
      user:sessionUser(staff_id: $staff_id, organization_id: $organization_id) {
        staff_user_status
      }
    }
  `

  const ENTERPRISE_BY_USER_QUERY = gql`
    query UserData($staff_id: ID!) {
      getAllEnterprisesByUid(staff_id: $staff_id) {
        enterprise_id
      }
    }
  `

  const { refetch: refetchEnterprises } = useQuery(ENTERPRISE_BY_USER_QUERY, {
    variables: { staff_id: userCtx.session.user.staff_id },
    skip: true,
  })

  const { refetch: refetchSessionData } = useQuery(SESSION_DATA_QUERY, {
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: userCtx.session.user.organization_id,
    },
    skip: true,
    onCompleted: async (data) => {
      if (data && data.user) {
        setUserStatus("ACTIVE")
      } else {
        setUserStatus("INACTIVE")

        try {
          const { data: enterpriseData } = await refetchEnterprises()
          if (
            enterpriseData &&
            enterpriseData.getAllEnterprisesByUid.length > 0
          ) {
            const firstEnterpriseId =
              enterpriseData.getAllEnterprisesByUid[0].enterprise_id
            userCtx.changeEnterprise(firstEnterpriseId)
          }
        } catch (error) {
          console.error("Error refetching enterprises:", error)
        }
      }
    },
  })

  useEffect(() => {
    refetchSessionData()
  }, [refetchSessionData])

  return (
    <div
      className="dropdown-title-container"
      style={{ marginLeft: 8, display: "flex", flexDirection: "column" }}
    >
      <span className="title-dropdown" style={{ fontSize: "11px" }}>
        Organization:
      </span>
      <Dropdown
        disabled={loading || props.fetching}
        value={userCtx.session.user.organization_id}
        options={sortedOrganizations}
        onChange={async ({ value }) => {
          await userCtx.changeOrganization(value)
          navigate("/")
        }}
        optionLabel="organization_name"
        optionValue="organization_id"
        placeholder="Organizations"
        filter={sortedOrganizations.length >= 5}
        style={{ marginBottom: 15 }}
      />
    </div>
  )
}
